import { getBaseURL } from '../services/baseAPI';

/**
 * Get full URL for static image path
 * Reuses the existing API base URL configuration
 */
export const getImageUrl = (imagePath: string): string => {
  const apiBaseUrl = getBaseURL();
  // Remove /api/v1 from the end to get the static files base URL
  const staticBaseUrl = apiBaseUrl.replace('/api/v1', '');
  return `${staticBaseUrl}/${imagePath}`;
}; 